
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Définition : qu’est-ce qu’un call-to-action ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "La création d’un site Internet ou d’une landing page nécessite de l’investissement. Vous devez ainsi utiliser ces pages Web pour multiplier vos contacts clients et accroître votre chiffre d’affaires.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Définition : qu’est-ce qu’un call-to-action ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "La création d’un site Internet ou d’une landing page nécessite de l’investissement. Vous devez ainsi utiliser ces pages Web pour multiplier vos contacts clients et accroître votre chiffre d’affaires.",
        },
      ],
    };
  },
};
